import * as React from 'react'
import { connect } from 'react-redux'
// tslint:disable-next-line:max-line-length
import OrientationTypeSelector from '../../molecules/orientation-type-selector'

import * as actions from '../../../actions'

type GetSuppliesProps = {
  uniqueLink: string
  setDropshipping?: any
  setSupplyAcquisitionMethod?: any
  supplyAcquisitionMethod?: string
}

export const GetSupplies: React.SFC<GetSuppliesProps> = ({
  uniqueLink,
  setDropshipping,
  setSupplyAcquisitionMethod,
}) => (
  <OrientationTypeSelector
    setSupplyAcquisitionMethod={setSupplyAcquisitionMethod}
    disableDropshipping={() => setDropshipping(uniqueLink, false)}
  />
)

const mapStateToProps = state => ({
  supplyAcquisitionMethod: state.supplyAcquisitionMethod,
})

const mapDispatchToProps = {
  setSupplyAcquisitionMethod: actions.setSupplyAcquisitionMethod,
  setDropshipping: actions.setDropshipping,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetSupplies)
